import { render, staticRenderFns } from "./add-empty-section.vue?vue&type=template&id=5950b9e5&scoped=true&"
import script from "./add-empty-section.vue?vue&type=script&lang=js&"
export * from "./add-empty-section.vue?vue&type=script&lang=js&"
import style0 from "./add-empty-section.vue?vue&type=style&index=0&id=5950b9e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950b9e5",
  null
  
)

export default component.exports